import NewHeader from "../components/NewHeader_dev";
import ProductCSS from "./Product_dev3.module.css";
import Product_dev from "../components/product_dev";
import Footer from "../components/Footer";

function Product() {
  return (
    <div className={ProductCSS.content}>
      <NewHeader />
      <Product_dev />
      <br />
            <br />          
            <Footer />          
    </div>
  );
}
export default Product;
